import DeclaracionConjuntaForm from './DeclaracionConjuntaForm.vue';

export default {
  install: (app, _options) => {
    app.component('Modelo233DeclaracionConjuntaForm', DeclaracionConjuntaForm);
  },
};
